export default __webpack_public_path__ + "static/contents.administration-52ffce5a9dbf789d111eeb061724c997.png";